import { useCallback, useState } from "react";

import { useAccessPattern } from "@hooks/useAccessPattern";

export function useRenewalDiscard() {
  const [renewalLocatorToDiscard, setRenewalLocatorToDiscard] = useState<
    string | undefined
  >();
  const [shouldRefetchListAfterDiscard, setShouldRefetchListAfterDiscard] =
    useState(false);

  const { canSeeDiscardedRenewals } = useAccessPattern();

  const showRenewalDiscardModal = useCallback(
    (renewalLocator: string, shouldRefetchList = false) => {
      if (!canSeeDiscardedRenewals) {
        return;
      }

      setRenewalLocatorToDiscard(renewalLocator);
      setShouldRefetchListAfterDiscard(shouldRefetchList);
    },
    [canSeeDiscardedRenewals]
  );

  const closeRenewalDiscardModal = useCallback(() => {
    setRenewalLocatorToDiscard(undefined);
    setShouldRefetchListAfterDiscard(false);
  }, []);

  return {
    renewalLocatorToDiscard,
    showRenewalDiscardModal,
    shouldRefetchListAfterDiscard,
    closeRenewalDiscardModal,
  };
}
